import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import moment from 'moment';
import 'moment/locale/es';
import Home from './containers/home/';
import ChevroletHome from './containers/chevroletHome/';
import NissanHome from './containers/nissanHome/';
import VolkswagenHome from './containers/volkswagenHome/';
import Wizard from './containers/wizard/';
import { Siniestro } from './containers/Siniestro';
import reducers from './reducers';
import './resources/scss/main.scss';

moment.locale('es');

const store = createStore(reducers, applyMiddleware(thunkMiddleware));

function App() {
  return (
    <Provider store={store}>
      <Router basename={window.activeBrand !== 'unconfigured' ? '/solicitar-turno' : ''}>
        {window.activeBrand !== 'unconfigured' && (
          <Switch>
            <Route path="/volkswagen" component={VolkswagenHome} exact />
            <Route path="/chevrolet" component={ChevroletHome} exact />
            <Route path="/nissan" component={NissanHome} exact />
            <Route path="/pedido" component={Wizard} exact />
            <Route path="/siniestro" component={Siniestro} exact />
            <Route component={Home} />
          </Switch>
        )}
        {window.activeBrand === 'unconfigured' && (
          <Switch>
            <Route path="/nissan" component={NissanHome} exact />
            <Route path="/volkswagen" component={VolkswagenHome} exact />
            <Route path="/chevrolet" component={ChevroletHome} exact />
            <Route path="/pedido" component={Wizard} exact />
            <Route path="/siniestro" component={Siniestro} exact />
            <Route component={Home} />
          </Switch>
        )}
      </Router>
    </Provider>
  );
}

export default App;
